// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","cta-link-card__container":"CTALinkCard_cta-link-card__container__6UXW3","cta-link-card__button":"CTALinkCard_cta-link-card__button__UojSL"};